(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["emmalicious-angelitos"] && !Shopify.designMode) return;
  try {
    (() => {
  const expire = () => {
    if (Date.now() >= Date.parse('2026-11-02T08:00:00Z')) {
      document.querySelectorAll('[data-angelitos-event]').forEach(element => element.remove());
      return true;
    }
    return false;
  };
  if (!expire()) {
    const timer = setInterval(() => { if (expire()) clearInterval(timer); }, 30000);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
